<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import Select from '$components/Form/Select.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const serviceTypeOptions = [
        `Ouverture de compte`,
        `Services de banque en ligne`,
        `Crédits et financements`,
        `Investissements`,
        `Autres (précisez)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const accountTypesOptions = [
        `Compte courant`,
        `Compte épargne`,
        `Compte professionnel`,
        `Compte pour étudiants`,
        `Autres (précisez)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const creditNeedOptions = [
        `Oui, pour un prêt personnel`,
        `Oui, pour un prêt immobilier`,
        `Oui, pour un financement d'entreprise`,
        `Non`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const communicationModeOptions = [
        `Application mobile`,
        `Site web`,
        `Téléphone`,
        `Agence physique`,
        `WhatsApp/SMS`,
        `Autres (précisez)`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.banque.serviceType}
        class=""
        let:field
        let:id
        label={`Quel type de service bancaire recherchez-vous actuellement ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={serviceTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.banque.accountTypes}
        class=""
        let:field
        let:id
        label={`Quel type de compte bancaire vous intéresse le plus ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={accountTypesOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.banque.creditNeed}
        class=""
        let:field
        let:id
        label={`Avez-vous besoin d'un service de crédit ou de financement ?`}
    >
        <Select
            {form}
            {field}
            {id}
            required={false}
            options={creditNeedOptions}
            placeholder="Sélectionnez une option"
        />
    </Row>

    <Row
        {form}
        field={fields.banque.communicationMode}
        class=""
        let:field
        let:id
        label={`Quel est votre mode de communication préféré pour interagir avec votre banque ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[300px]:grid-cols-2 @[500px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={communicationModeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
